import React from 'react';
import Header from './component/Header';
import PublicFooter from '../components/layout/PublicFooter';

const Welcome = () => {
  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-bg-gray-50">
      <Header />

      {/* Hero */}
      <div className="tw-bg-gradient-to-br tw-from-blue-600 tw-to-blue-700 tw-text-white tw-text-center tw-py-16 tw-px-4">
        <div className="tw-max-w-2xl tw-mx-auto">
          <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-16 tw-h-16 tw-rounded-full tw-bg-white/20 tw-mb-6">
            <svg className="tw-w-8 tw-h-8 tw-text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h1 className="tw-text-3xl tw-font-bold tw-mb-3">You're All Set!</h1>
          <p className="tw-text-blue-100 tw-text-lg tw-mb-8">Your journey to hassle-free tag renewal starts now. Here's what happens next.</p>
          <a href="/" className="tw-inline-flex tw-items-center tw-gap-2 tw-bg-white tw-text-blue-600 tw-font-semibold tw-px-6 tw-py-3 tw-rounded-lg hover:tw-bg-blue-50 tw-transition-colors tw-no-underline">
            Go to Dashboard
            <svg className="tw-w-4 tw-h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </a>
        </div>
      </div>

      {/* Steps */}
      <div className="tw-max-w-5xl tw-mx-auto tw-px-4 tw-py-16 tw-flex-1">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-8">

          {/* Step 1 */}
          <div className="tw-bg-white tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-200 tw-p-8 tw-text-center">
            <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-full tw-bg-blue-100 tw-text-blue-600 tw-mb-5">
              <svg className="tw-w-7 tw-h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
              </svg>
            </div>
            <div className="tw-text-sm tw-font-semibold tw-text-blue-600 tw-uppercase tw-tracking-wide tw-mb-2">Step 1</div>
            <h3 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-mb-3">Email Notification &amp; Payment Confirmation</h3>
            <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed tw-m-0">
              We'll send you an email detailing the cost for your tag renewal. After reviewing, we'll process the charge for our renewal service.
            </p>
          </div>

          {/* Step 2 */}
          <div className="tw-bg-white tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-200 tw-p-8 tw-text-center">
            <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-full tw-bg-green-100 tw-text-green-600 tw-mb-5">
              <svg className="tw-w-7 tw-h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
              </svg>
            </div>
            <div className="tw-text-sm tw-font-semibold tw-text-green-600 tw-uppercase tw-tracking-wide tw-mb-2">Step 2</div>
            <h3 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-mb-3">Automated Renewal Management</h3>
            <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed tw-m-0">
              Three weeks before your tag's due date, we automatically renew your vehicle's registration. This auto-renewal continues each year for hassle-free coverage.
            </p>
          </div>

          {/* Step 3 */}
          <div className="tw-bg-white tw-rounded-xl tw-shadow-sm tw-border tw-border-gray-200 tw-p-8 tw-text-center">
            <div className="tw-inline-flex tw-items-center tw-justify-center tw-w-14 tw-h-14 tw-rounded-full tw-bg-purple-100 tw-text-purple-600 tw-mb-5">
              <svg className="tw-w-7 tw-h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0H21M3.375 14.25h3.417c.28 0 .548.112.746.31l2.175 2.181a1.062 1.062 0 001.504 0l2.175-2.181a1.062 1.062 0 01.746-.31h3.417m-13.18 0V5.625c0-.621.504-1.125 1.125-1.125h9.75c.621 0 1.125.504 1.125 1.125v8.625" />
              </svg>
            </div>
            <div className="tw-text-sm tw-font-semibold tw-text-purple-600 tw-uppercase tw-tracking-wide tw-mb-2">Step 3</div>
            <h3 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-mb-3">Tag Delivery to Your Doorstep</h3>
            <p className="tw-text-sm tw-text-gray-600 tw-leading-relaxed tw-m-0">
              Once your renewal is approved by the county, your new tags will be mailed directly to you. Simply check your mailbox — it's that convenient.
            </p>
          </div>
        </div>

        {/* Warning notice */}
        <div className="tw-mt-10 tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-xl tw-p-5 tw-text-center">
          <p className="tw-text-sm tw-text-blue-800 tw-m-0 tw-leading-relaxed">
            <strong>Important:</strong> Do not attempt to renew your tags again, as this may cause a duplicate charge and delay in receiving your tags. If you need assistance, reach out to <a href="mailto:hello@renewmytags.com" className="tw-text-blue-600 tw-font-medium hover:tw-underline">hello@renewmytags.com</a>.
          </p>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default Welcome;
